import React from "react";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { SurveyAnswersReview } from "../../components/surveys/SurveyAnswersReview";
import { ProgressFooter, ProgressFooterActions } from "../get-compliant/ProgressFooter";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";
import { usePrimaryOrganization } from "../../hooks";
import { useOnboardingProgress } from "../../../common/hooks/useOnboardingProgress";

export function BusinessSurveySettingsPage() {
  const history = useHistory();
  const [org] = usePrimaryOrganization();
  const [onboardingProgress] = useOnboardingProgress(org?.id);
  // Finishing the survey lands here with every answer in place, so the review's own "incomplete
  // on first load" footer never shows. Keep the forward path until the user reaches the Vendor
  // List step, the same way that page keeps its footer through the data map stretch.
  const isBeforeVendorList =
    org?.finishedOnboardingLatch === false &&
    onboardingProgress != null &&
    !onboardingProgress.dataMapOnboardingProgress.isVendorInventoryComplete;

  return (
    <SurveyAnswersReview
      render={(isSurveyComplete, pageBody, { showOnboardingFooter }) => {
        return (
          <StandardPageWrapper
            fullWidth
            footer={
              (showOnboardingFooter || (isBeforeVendorList && isSurveyComplete !== null)) && (
                <ProgressFooter
                  actions={
                    <ProgressFooterActions
                      nextContent="Done Reviewing"
                      nextDisabled={!isSurveyComplete}
                      nextOnClick={() => {
                        history.push(Routes.dashboard.root);
                      }}
                    />
                  }
                />
              )
            }
          >
            {pageBody}
          </StandardPageWrapper>
        );
      }}
    />
  );
}
